require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// C:/angular/aws-lex-web-ui-master/aws-lex-web-ui-master/node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = ../../../node_modules/core-js/library/modules/es7.symbol.observable.js
// module chunks = 0